export default {
    clientData(dBrainData) {
        return {
            filter: {
                resident: !!dBrainData.resident,
                person  : true,
                verify  : false,
            },
            client: {
                economics_sector_id: 10,
                activity_kind_id:    250,
                patronymic:          this.checkValue(dBrainData.patronymic),
                birthday:            this.checkValue(dBrainData.birthday) ? this.toFieldDate(this.checkValue(dBrainData.birthday)) : '',
                surname:             this.checkValue(dBrainData.surname) ?? 'Без фамилии',
                email:               '',
                phone:               '',
                name:                this.checkValue(dBrainData.name),
                iin:                 '',
                sex:                 this.checkValue(dBrainData.sex),
                id:                  0,
            },
            document: {
                type_id: dBrainData.type_id,
                issued:  this.checkValue(dBrainData.document.issued) ? this.toFieldDate(this.checkValue(dBrainData.document.issued)) : '',
                number:  this.checkValue(dBrainData.document.number),
                issuer:  this.checkValue(dBrainData.document.issuer),
                until:   this.checkValue(dBrainData.document.until) ? this.toFieldDate(this.checkValue(dBrainData.document.until)) : '',
            },
            location: {
                country_id: dBrainData.country_id,
                address:    null
            }
        }
    },
    checkValue(val) {
        // if (val && 'confidence' in val) {
        if (val) {
            return val && 'value' in val ? val.value : null
        } else return null
    },
    toFieldDate(date) {
        const day   = date.slice(0, 2)
        const month = date.slice(3, 5)
        const year  = date.slice(6, 10)
        return year+'-'+month+'-'+day
    }
}